export enum LoginResponse {
    Incorrect,
    Locked,
    Success,
    MfaCodeRequired,
}


// WEBPACK FOOTER //
// ./src/enums/LoginResponse.tsx